import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Welcome.css";



/* ── Slide 1: hero image (man with eToro card) ── */
const HeroVisual = () => (
  <div className="slide-hero-img-wrap">
    <img src="/promo-hero.png" alt="eToro Visa Card" className="slide-hero-img" />
    <div className="slide-hero-fade" />
  </div>
);

/* ── Slide 2: airport lounge photo ── */
const LoungeVisual = () => (
  <div className="slide-photo-wrap">
    <img src="https://images.unsplash.com/photo-1530521954074-e64f6810b32d?auto=format&fit=crop&w=800&h=600&q=85" alt="Airport lounge" className="slide-photo" />
    <div className="slide-photo-fade" />
  </div>
);

/* ── Slide 3: purchase protection photo ── */
const ProtectionVisual = () => (
  <div className="slide-photo-wrap">
    <img src="https://images.unsplash.com/photo-1563013544-824ae1b704d3?auto=format&fit=crop&w=800&h=600&q=85" alt="Purchase protection" className="slide-photo" />
    <div className="slide-photo-fade" />
  </div>
);
/* ── Slide 4: stock-back / earning photo ── */
const EarningVisual = () => (
  <div className="slide-photo-wrap">
    <img
      src="https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?auto=format&fit=crop&w=800&h=600&q=85"
      alt="Stock chart"
      className="slide-photo slide-photo-flipped"
    />
    <div className="slide-photo-fade" />
  </div>
);

const SLIDES = [
  {
    visual: <HeroVisual />,
    title: "Your Visa card,\nsupercharged.",
    subtitle: "Premium benefits designed for eToro Club members. Travel, protect, and earn — all from one card.",
  },
  {
    visual: <LoungeVisual />,
    title: "1,300+ airport\nlounges worldwide.",
    subtitle: "Skip the crowds. Enjoy complimentary food, drinks, WiFi and showers at the world's best airports.",
  },
  {
    visual: <ProtectionVisual />,
    title: "Every purchase,\nautomatically protected.",
    subtitle: "90-day purchase protection, extended warranty, and trip insurance — built right into your card.",
  },
  {
    visual: <EarningVisual />,
    title: "Earn up to 5%\nstock-back rewards.",
    subtitle: "Every purchase earns you real stocks. Any tier, any spend — with up to $12,000/year in premium card benefits.",
  },
];

export default function Welcome({ onEnter }) {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [showSignIn, setShowSignIn] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const slide = SLIDES[currentSlide];
  const isLast = currentSlide === SLIDES.length - 1;

  function handleNext() {
    if (isLast) setShowSignIn(true);
    else setCurrentSlide((s) => s + 1);
  }
  function handleSkip() { setShowSignIn(true); }
  function handleSignIn() { onEnter(); navigate("/"); }

  /* ── Sign-in screen ── */
  if (showSignIn) {
    return (
      <div className="si-screen">
        <div className="si-card">
          <h1 className="si-title">Sign in</h1>

          {/* Username */}
          <div className="si-field">
            <input className="si-input" type="text" placeholder="Username or Email"
              value={email} onChange={e => setEmail(e.target.value)} autoComplete="username" />
            {!email && <span className="si-field-error">Missing Username</span>}
          </div>

          {/* Password */}
          <div className="si-field">
            <input className="si-input" type="password" placeholder="Password"
              value={password} onChange={e => setPassword(e.target.value)} autoComplete="current-password" />
            <button className="si-forgot" type="button" onClick={handleSignIn}>Forgot password?</button>
          </div>

          {/* Keep logged in */}
          <label className="si-remember">
            <span className="si-checkbox checked">
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                <polyline points="2,6 5,9 10,3" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </span>
            <span className="si-remember-text">Keep me logged in for 30 days</span>
          </label>

          {/* Sign in btn */}
          <button className="si-btn-primary" onClick={handleSignIn}>Sign in</button>

          {/* OR */}
          <div className="si-or">
            <span className="si-or-line" />
            <span className="si-or-label">OR</span>
            <span className="si-or-line" />
          </div>

          {/* Social buttons */}
          <button className="si-social-btn" onClick={handleSignIn}>
            <svg width="18" height="18" viewBox="0 0 24 24"><path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/><path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/><path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05"/><path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/></svg>
            Sign in with Google
          </button>

          <button className="si-social-btn" onClick={handleSignIn}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="white"><path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/></svg>
            Sign in with Apple
          </button>

          <button className="si-social-btn" onClick={handleSignIn}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="#1877F2"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
            Sign in with Facebook
          </button>

          <p className="si-footer">Don't have an account? <button className="si-signup-link" onClick={handleSignIn}>Sign up</button></p>
        </div>
      </div>
    );
  }

  /* ── Onboarding slides ── */
  return (
    <div className="welcome">
      <div className="welcome-bg" />

      <header className="welcome-header">
<button className="welcome-skip" onClick={handleSkip}>Skip</button>
      </header>

      {/* Visual — fills upper area */}
      <div className="welcome-visual">
        {slide.visual}
      </div>

      {/* Text + nav */}
      <div className="welcome-content">
        <h1 className="welcome-title">{slide.title}</h1>
        <p className="welcome-subtitle">{slide.subtitle}</p>
      </div>

      <div className="welcome-footer">
        <div className="welcome-dots">
          {SLIDES.map((_, i) => (
            <span key={i} className={`welcome-dot ${i === currentSlide ? "active" : ""}`}
              onClick={() => setCurrentSlide(i)} />
          ))}
        </div>
        <button className="welcome-cta" onClick={handleNext}>
          {isLast ? "Get Started" : "Next"}
        </button>
        <p className="welcome-legal">
          eToro Visa Benefits are subject to eligibility and terms.<br />
          Capital at risk. Past performance is not indicative of future results.
        </p>
      </div>
    </div>
  );
}
